//will be used as interface for recallWizard

import { StatusDto } from "../../../enums/Domain/Status"

export interface IRecallData {
    recallId: string
    fullRef: string
    accountId: string
    isDigital: boolean
    inventory: IRecallItem[]
}

export interface IRecallItem {
    caseId?: string
    rangeId: string
    packingBoxId: string
    intent: Intent
    materialType: IMaterialType,
    reference: string,
    resultType: string,
    year: string,
    status: StatusDto,
    canBeRecalledInWholeBoxes: boolean,
    partCases: IPartCase[][]
    requestorComments?: string
}

export interface IMaterialType {
    id: string
    name: string
}

export interface IPartCase {
    specimenId?: string
    reference: string,
}

export enum Intent {
    WholeBox = "WholeBox",
    WholeCase = "WholeCase",
    PartCase = "PartCase",
}

